import React from 'react';
import { useTranslation } from 'react-i18next';
import { ASSET_IMAGES } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

const AssetClasses = () => {
  const { t } = useTranslation();
  const items = t('assets.items', { returnObjects: true });
  return (
    <section id="assets" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-[820px] mb-12 md:mb-16">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#5FE0C8] mb-4">{t('assets.eyebrow')}</div>
          <h2 className="font-display text-[44px] md:text-[60px] leading-[0.98] tracking-tight">
            {t('assets.heading1')} <span className="font-serif-i text-[#5FE0C8]">{t('assets.heading2')}</span>
          </h2>
          <p className="mt-5 text-[15px] text-[#9FA8A4] leading-relaxed max-w-[520px]">
            {t('assets.intro')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {items.map((a, i) => (
            <article
              key={i}
              data-testid={`asset-card-${i}`}
              className="group relative rounded-2xl overflow-hidden panel-card hover:border-[#5FE0C8]/40 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[5/4] overflow-hidden">
                <img
                  src={ASSET_IMAGES[i]}
                  alt={a.tag}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#07120F]/55 via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 rounded-full text-[10.5px] tracking-[0.22em] uppercase text-[#ECE9DF] bg-black/45 backdrop-blur-md border border-white/15">
                    {a.tag}
                  </span>
                </div>
              </div>

              <div className="p-6 md:p-7 flex-1 flex flex-col">
                <h3 className="font-display text-[24px] md:text-[26px] leading-tight tracking-tight text-[#ECE9DF]">
                  {a.title}
                </h3>
                <p className="mt-2.5 text-[14px] text-[#9FA8A4] leading-relaxed flex-1">
                  {a.body}
                </p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-[11.5px] tracking-[0.18em] uppercase text-[#5FE0C8] opacity-80 group-hover:opacity-100 transition-opacity">
                  {t('assets.viewMandate')} <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AssetClasses;
